import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", {
  class: "section-heading",
  "data-text": "Contact"
}, null, -1)
const _hoisted_2 = {
  class: "contact-form",
  ref: "contactForm",
  method: "POST"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "form-input glass-tile" }, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "text",
    class: "input-valid",
    placeholder: "Name*",
    name: "name",
    autocomplete: "name",
    "aria-label": "Name Form Input"
  })
], -1)
const _hoisted_4 = { class: "form-input glass-tile" }
const _hoisted_5 = {
  type: "email",
  class: "input-valid",
  ref: "email",
  placeholder: "Email*",
  name: "email",
  autocomplete: "email",
  "aria-label": "Email Form Input"
}
const _hoisted_6 = { class: "form-input glass-tile form-tumbleweed" }
const _hoisted_7 = {
  type: "text",
  ref: "tumbleweed",
  placeholder: "Address",
  name: "address",
  "aria-label": "Address Form Input"
}
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"form-input glass-tile\"><input type=\"text\" class=\"input-valid\" placeholder=\"Subject*\" name=\"subject\" aria-label=\"Subject Form Input\"></div><div class=\"form-input glass-tile\"><input type=\"text\" placeholder=\"Company\" name=\"company\" autocomplete=\"organization\" aria-label=\"Company Form Input\"></div><div class=\"form-input form-textarea glass-tile\"><textarea class=\"input-valid\" placeholder=\"Message*\" name=\"message\" aria-label=\"Message Form Input\"></textarea></div>", 3)
const _hoisted_11 = { class: "form-footer" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h3", {
  class: "send-btn-txt",
  "data-text": "Submit"
}, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"form-socials\"><a href=\"https://github.com/newhorizonweb\" class=\"form-link form-link1\" aria-label=\"GitHub Link\" target=\"_blank\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200 200\"><path class=\"anim-elem1 cls-1\" d=\"M82.6,144.3c-21.1-2.4-43.2-10.5-43.2-46.9a36,36,0,0,1,9.8-25.5,33.5,33.5,0,0,1,.9-25.1s7.9-2.6,26.1,9.7a89.1,89.1,0,0,1,47.5,0c18.1-12.3,26.1-9.7,26.1-9.7a34,34,0,0,1,.9,25.1,36.8,36.8,0,0,1,9.8,25.5c0,36.4-22.1,44.4-43.3,46.8\"></path><path class=\"cls-1\" d=\"M117.2,144.2a22.7,22.7,0,0,1,6.4,17.7v26c0,3.2,1.7,5.5,6.5,4.5a95.1,95.1,0,1,0-60.1,0c4.7.9,6.5-2,6.5-4.4V171.9c-26.5,5.7-32-12.8-32-12.8a25.4,25.4,0,0,0-10.7-14c-8.7-5.9.6-5.8.6-5.8a19.4,19.4,0,0,1,14.5,9.8c8.5,14.5,22.1,10.3,27.7,7.9a20.5,20.5,0,0,1,6-12.7\"></path></svg></a><a href=\"https://www.linkedin.com/in/wojciech-bocho/\" aria-label=\"LinkedIn Link\" class=\"form-link form-link2\" target=\"_blank\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200 200\"><circle class=\"anim-elem1 cls-1\" cx=\"27.8\" cy=\"27.8\" r=\"22.7\"></circle><rect class=\"anim-elem2 cls-1\" x=\"7.7\" y=\"68.6\" width=\"40.6\" height=\"126.25\" rx=\"2\"></rect><path class=\"cls-1\" d=\"M195,116.1c0-7.9,0-14.2-3.2-23.6A42.5,42.5,0,0,0,171,68.6c-2-1-20.7-10.5-39.9-1-12.7,6.4-18.5,16.8-19.9,24.6h0V70.6a2,2,0,0,0-2-2H74.6a2,2,0,0,0-2,2V192.9a2,2,0,0,0,2,2h34.6c2-1.2,2-1.9,2-2V127.8s-.5-18.2,10.4-25.1a24.2,24.2,0,0,1,24.8-.3c8.5,5.2,9.9,13.7,9.9,27.8v62.6a2,2,0,0,0,2,2H193c2-1.1,2-1.9,2-2V116.1\"></path></svg></a></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormPopup = _resolveComponent("FormPopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("form", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("input", _hoisted_5, null, 512)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("input", _hoisted_7, null, 512)
      ]),
      _hoisted_8,
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          class: "send-form-btn glass-tile",
          ref: "sendFormBtn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.sendForm && _ctx.sendForm(...args))),
          "aria-label": "Submit the contact form"
        }, _hoisted_13, 512),
        _hoisted_14
      ])
    ], 512),
    _createVNode(_component_FormPopup, {
      popupVisible: _ctx.popupVisible,
      popupMsg: _ctx.popupMsg,
      onClosePopup: _ctx.closePopup
    }, null, 8, ["popupVisible", "popupMsg", "onClosePopup"])
  ], 64))
}